import {
  SortableTh,
  SortingDirection,
  Table as CoreTable,
  TableWrapper,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@components/core-ui/Table';
import { IconButtonRegular as IconButton } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonRegular';
import { IconButtonDelete } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonDelete';
import DoneIcon from '@components/icons/Done.svg';
import EditIcon from '@components/icons/Edit.svg';
import TrashBin from '@components/icons/TrashBin.svg';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Fragment } from 'react';

import { usePageContext } from '../../../../providers/PageProvider';
import { InlineEditRow } from './components/InlineEditRow';
import { OrganizationsPreview } from './components/OrganizationsPreview';
import { CellContent } from './styles/CellContent';
import { FlexCellContent } from './styles/FlexCellContent';
import { StyledLink } from './styles/StyledLink';
import { EntityIcon } from '@components/core-ui/EntityIcon/';

export const Table = () => {
  const { me } = useAuthContext();
  const { users, sortingReverse, editId, setEditId, sortingField, deleteUser, toggleSort } = usePageContext();

  return (
    <TableWrapper>
      <CoreTable>
        <Thead>
          <Tr>
            <Th style={{ width: '1%' }}></Th>
            <SortableTh style={{ width: '20%' }} onClick={() => toggleSort('name')}>
              Name
              {sortingField === 'name' && <SortingDirection reverse={sortingReverse} />}
            </SortableTh>
            <Th style={{ width: '50%' }}>Contacts</Th>
            <SortableTh style={{ width: '1%' }} onClick={() => toggleSort('createdAt')}>
              Created
              {sortingField === 'createdAt' && <SortingDirection reverse={sortingReverse} />}
            </SortableTh>
            <Th style={{ width: '1%' }}>Organizations</Th>
            <Th style={{ width: '1%' }}></Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.data?.map((data) => {
            const avatarName = `${data?.name[0]}${data?.lastname[0]}`;
            return (
              <Fragment key={data.id}>
                <Tr>
                  <Td>
                    <FlexCellContent>
                      <EntityIcon src={data.avatar} name={avatarName} />
                    </FlexCellContent>
                  </Td>
                  <Td>
                    <FlexCellContent>
                      <StyledLink to={routes.adminUserDetails.make(data.id)}>
                        {data.name} {data.lastname}
                      </StyledLink>
                    </FlexCellContent>
                  </Td>
                  <Td>
                    <FlexCellContent>
                      <CellContent>
                        <div>{data.email}</div>
                        <div>{data.phone}</div>
                      </CellContent>
                    </FlexCellContent>
                  </Td>
                  <Td>
                    <FlexCellContent>{getAmericanTime(data.createdAt)}</FlexCellContent>
                  </Td>
                  <Td>
                    <FlexCellContent className="!overflow-visible">
                      <OrganizationsPreview organizations={data.organizations || []} />
                    </FlexCellContent>
                  </Td>
                  <Td>
                    <FlexCellContent className="flex items-center gap-5">
                      {data.id !== editId ? (
                        <IconButton title="Edit" onClick={() => setEditId(data.id)}>
                          <EditIcon />
                        </IconButton>
                      ) : null}
                      {data.id === editId ? (
                        <IconButton title="Done" onClick={() => setEditId('')}>
                          <DoneIcon width={18} height={14} />
                        </IconButton>
                      ) : null}
                      <IconButtonDelete disabled={me.id === data.id} title="Remove" onClick={() => deleteUser(data.id)}>
                        <TrashBin />
                      </IconButtonDelete>
                    </FlexCellContent>
                  </Td>
                </Tr>
                <InlineEditRow data={data} />
              </Fragment>
            );
          })}
        </Tbody>
      </CoreTable>
    </TableWrapper>
  );
};
